import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Layout, Button, Row, Col, message, Modal, Form, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  getSuppliersService,
  getSupplierService,
  getPurchaseService,
  getMaterialService,
  getMetalsService,
  postSupplierSelectedService,
  postAddToPurchaseService,
  postSupplierService,
  postMetalService,
  putCompletePurchaseService,
  putMaterialService,
  putSmallTransactionService,
  deleteMaterialService,
  getCategoriesService,
  putPurchaseDateService,
} from "./NewPurchasePageService";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import ScaleReading from "../../components/ScaleReading/ScaleReading";
import PurchaseForm from "../../components/PurchaseForm/PurchaseForm";
import Loader from "../../components/Loader/Loader";
import "./NewPurchasePage.css";
import { removeTokenFromCookies } from "../../utils/cookies";
import Cookies from "universal-cookie";
import Copyright from "../../components/Copyright/Copyright";
import ScaleCamera from "../../components/ScaleCamera/ScaleCamera";
import { webcamDeviceIDs } from "../../constants/webcamIDs";

const { Content } = Layout;

export interface NewPurchasePageProps {
  scaleSerialPort: any;
  scaleReader: any;
  updateScaleSerialPort: (port: any) => void;
  updateScaleReader: (reader: any) => void;
}

const NewPurchasePage = (props: NewPurchasePageProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [suppliers, setSuppliers] = useState([]);
  const [weight, setWeight] = useState("0.0");
  const [purchaseID, setPurchaseID] = useState("");
  const [portAccessModalOpen, setPortAccessModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [weightReadingTextDummy, setWeightReadingTextDummy] = useState("");
  const [scaleImageSrc, setScaleImageSrc] = useState("");
  const [materialImageSrc, setMaterialImageSrc] = useState("");
  const [showSelectSupplierForm, setShowSelectSupplierForm] = useState(true);
  const [selectedSupplierInfo, setSelectedSupplierInfo] = useState({}) as any;
  const [purchaseInfo, setPurchaseInfo] = useState({}) as any;
  let location = useLocation();
  let navigate = useNavigate();
  const scaleWebcamRef = useRef(null) as any;
  const materialWebcamRef = useRef(null) as any;
  const cookies = new Cookies();
  const token = cookies.get("TOKEN");
  const currOffice = cookies.get("CURR_OFFICE");

  useEffect(() => {
    navToSelectOffice();
    isPortEnabled();
    if (token) {
      getSuppliers();
    }
  }, [token, props.scaleSerialPort]);

  useEffect(() => {
    if (props.scaleReader !== null) getReadingValue(props.scaleReader);
  }, [props.scaleReader, weightReadingTextDummy]);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const isPortEnabled = () => {
    if (props.scaleSerialPort === null) setPortAccessModalOpen(true);
  };

  const getPurchase = async (purchaseIDFromURL: string) => {
    try {
      setLoading(true);
      const res = await getPurchaseService(currOffice, purchaseIDFromURL);
      setPurchaseID(res.data.purchaseID);
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getPurchase error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMaterial = async (materialID: string) => {
    try {
      setLoading(true);
      const res = await getMaterialService(materialID);
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getMaterial error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const getSuppliers = async () => {
    try {
      setLoading(true);
      const res = await getSuppliersService();
      const suppliersData =
        currOffice === "pg" ? res.data.pgSuppliers : currOffice === "bw" ? res.data.bwSuppliers : [];
      setSuppliers(suppliersData);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getSuppliers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      // setMetals(res.data);
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getCategories = async () => {
    try {
      setLoading(true);
      const res = await getCategoriesService();
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getCategories error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postSupplierSelected = async (supplierID: string, dateString: string, isSmallTransaction: boolean) => {
    try {
      const dateProperties = dateString.split("/");
      const date =
        dateString !== "" && dateString !== undefined
          ? new Date(`${dateProperties[2]}-${dateProperties[1]}-${dateProperties[0]}`).toISOString()
          : new Date().toISOString();
      setLoading(true);
      const payload = {
        supplierID: supplierID,
        office: currOffice,
        date: date,
        smallTransaction: isSmallTransaction,
      };
      const res = await postSupplierSelectedService(payload);
      setPurchaseInfo(res.data);
      getSelectedSupplierInfo(res.data.supplierID);
      if (res.data.purchaseID) {
        setPurchaseID(res.data.purchaseID);
        window.history.pushState(null, "", `purchase/${res.data.purchaseID}`);
      }
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("postSupplierSelected error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getSelectedSupplierInfo = (supplierID: any) => {
    if (suppliers === undefined || suppliers.length === 0) return;
    const supplierInfo = suppliers.find((supplier: any) => supplier.supplierID === supplierID);
    setSelectedSupplierInfo(supplierInfo);
    setShowSelectSupplierForm(false);
  };

  const putMaterial = async (materialInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        materialID: materialInfo.materialID,
        name: materialInfo.name,
        rawWeight: materialInfo.rawWeight,
        wasteWeight: materialInfo.wasteWeight,
        netWeight: String(materialInfo.netWeight),
        manualEntry: materialInfo.manualEntry,
        smallBag: materialInfo.smallBag,
        bigBag: materialInfo.bigBag,
        jumboBag: materialInfo.jumboBag,
        other: materialInfo.other,
        metalID: materialInfo.metalID,
        scaleImageSrc: scaleImageSrc,
        materialImageSrc: materialImageSrc,
        notes: materialInfo.notes,
        office: currOffice,
      };
      const res = await putMaterialService(payload);
      setScaleImageSrc("");
      setMaterialImageSrc("");
      setLoading(false);
      return res;
    } catch (e: any) {
      setLoading(false);
      console.error("putPurchase error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postAddToPurchase = async (materialInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        materialID: materialInfo.key,
        name: materialInfo.name,
        rawWeight: materialInfo.rawWeight,
        wasteWeight: materialInfo.wasteWeight,
        netWeight: materialInfo.netWeight,
        price: 0.0,
        purchaseID: purchaseID,
        notes: materialInfo.notes,
        manualEntry: materialInfo.manualEntry,
        smallBag: materialInfo.smallBag,
        bigBag: materialInfo.bigBag,
        jumboBag: materialInfo.jumboBag,
        other: materialInfo.other,
        office: currOffice,
        metalID: materialInfo.metalID,
        scaleImageSrc: materialInfo.scaleImageSrc,
        materialImageSrc: materialInfo.materialImageSrc,
        packageType: materialInfo.packageType,
        purchaseCreatedTimestamp: purchaseInfo.createdTimestamp,
      };
      const res = await postAddToPurchaseService(payload);
      setScaleImageSrc("");
      setMaterialImageSrc("");
      setLoading(false);
      return res.data;
      // if (res.data.purchaseID) setPurchaseID(res.data.purchaseID);
    } catch (e: any) {
      setLoading(false);
      console.error("postAddToPurchase error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postSupplier = async (supplierInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        name: supplierInfo.name,
        companyName: supplierInfo.companyName,
        identificationCardNumber: supplierInfo.identificationCardNumber.replaceAll(" ", "").replaceAll("-", ""),
        contactNumber: "",
        email: "",
        address: "",
        companyCode: "",
        outstandingAmount: 0.0,
        passportNumber: supplierInfo.passportNumber,
      };
      const res = await postSupplierService(payload);
      setTimeout(async () => {
        setLoading(false);
        await getSuppliers();
      }, 1000);
    } catch (e: any) {
      setLoading(false);
      console.error("postSupplier error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postMetal = async (metalInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        name: metalInfo.name.trim(),
        displayName:
          metalInfo.displayName === "" || metalInfo.displayName === null || metalInfo.displayName === undefined
            ? metalInfo.name.trim()
            : metalInfo.displayName.trim(),
        category: metalInfo.category,
      };
      const res = await postMetalService(payload);
      setTimeout(async () => {
        setLoading(false);
        await getMetals();
      }, 1000);
    } catch (e: any) {
      setLoading(false);
      console.error("postMetal error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postCompletePurchase = async (
    materialsList: any[],
    notes: string,
    totalNetWeight: Number,
    totalNumMaterials: Number
  ) => {
    try {
      setLoading(true);
      const payload: any = {
        purchaseID: purchaseID,
        completed: true,
        supplierInfo: selectedSupplierInfo,
        notes: notes,
        totalNetWeight: totalNetWeight,
        totalNumMaterials: totalNumMaterials,
      };
      const resPurchase = await getPurchase(purchaseID);
      payload.purchaseDate = resPurchase.createdTimestamp;
      const res = await putCompletePurchaseService(payload);
      setLoading(false);
      navigate("/purchases");
      // if (res.data.purchaseID) setPurchaseID(res.data.purchaseID);
    } catch (e: any) {
      setLoading(false);
      console.error("postCompletePurchase error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const putSmallTransaction = async () => {
    try {
      setLoading(true);
      const resSmallTransaction = await putSmallTransactionService(purchaseID);
      let currPurchaseInfo = { ...purchaseInfo };
      currPurchaseInfo.smallTransaction = !currPurchaseInfo.smallTransaction;
      setPurchaseInfo(currPurchaseInfo);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("postCompletePurchase error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const putPurchaseDate = async (dateString: string) => {
    try {
      setLoading(true);
      const dateProperties = dateString.split("/");
      const date =
        dateString !== "" && dateString !== undefined
          ? new Date(`${dateProperties[2]}-${dateProperties[1]}-${dateProperties[0]}`).toISOString()
          : new Date().toISOString();
      const payload: any = {
        date: date,
      };
      const resUpdateDate = await putPurchaseDateService(purchaseID, payload);
      // let currPurchaseInfo = { ...purchaseInfo };
      // currPurchaseInfo.createdTimestamp = new Date(date).toLocaleDateString("en-GB");
      // setPurchaseInfo(currPurchaseInfo);
      setLoading(false);
      window.location.reload();
    } catch (e: any) {
      setLoading(false);
      console.error("putPurchaseDate error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const recordMaterial = () => {
    setScaleImageSrc("");
    setMaterialImageSrc("");
    setTimeout(() => {
      const scaleImage = captureScaleImage();
      const materialImage = captureMaterialImage();
      // return {
      //   rawWeight: Number(weight).toFixed(1),
      //   scaleImage: scaleImage,
      //   materialImage: materialImage,
      // };
    }, 500);
    return Number(weight).toFixed(1);
  };

  const captureScaleImage = useCallback(() => {
    if (scaleImageSrc === "") {
      if (scaleWebcamRef.current !== "") {
        const scaleImageSrc = scaleWebcamRef.current.getScreenshot();
        setScaleImageSrc(scaleImageSrc);
        return scaleImageSrc;
      } else {
        setScaleImageSrc("");
        setTimeout(() => {
          const scaleImageSrc = scaleWebcamRef.current.getScreenshot();
          setScaleImageSrc(scaleImageSrc);
          return scaleImageSrc;
        }, 1000);
      }
    }
  }, [scaleWebcamRef]);

  const captureMaterialImage = useCallback(() => {
    if (materialImageSrc === "") {
      if (materialWebcamRef.current !== "") {
        const materialImageSrc = materialWebcamRef.current.getScreenshot();
        setMaterialImageSrc(materialImageSrc);
        return materialImageSrc;
      } else {
        setMaterialImageSrc("");
        setTimeout(() => {
          const materialImageSrc = materialWebcamRef.current.getScreenshot();
          setMaterialImageSrc(materialImageSrc);
          return materialImageSrc;
        }, 1000);
      }
    }
  }, [materialWebcamRef]);

  const resetImageViews = () => {
    setScaleImageSrc("");
    setMaterialImageSrc("");
  };

  const getReadingValue = async (reader: any) => {
    let weightReadingText = "";
    const { value, done } = await reader.read();
    setWeightReadingTextDummy(String(Math.random()));
    if (value) {
      weightReadingText += value;
      if (/\r\n/i.test(weightReadingText)) {
        let recordWeight = weightReadingText.trim().split("kg")[0];
        if (!isNaN(Number(recordWeight))) setWeight(Number(recordWeight).toFixed(1));
        weightReadingText = "";
      }
    }
    if (done) {
      reader.releaseLock();
    }
  };

  const getPortAccess = async () => {
    try {
      setPortAccessModalOpen(false);
      const port = await (window.navigator as any).serial.requestPort();
      props.updateScaleSerialPort(port);
      await port.open({ baudRate: 9600, bufferSize: 1000000 });
      const textDecoder = new TextDecoderStream();
      port.readable.pipeTo(textDecoder.writable);
      const reader = textDecoder.readable.getReader();
      props.updateScaleReader(reader);
    } catch (e: any) {
      setPortAccessModalOpen(false);
      console.error("getPortAccess error", e);
    }
  };

  const updateLoading = (loading: boolean) => {
    setLoading(loading);
  };

  const resetNewPurchasePage = () => {
    toggleSidebar(true);
  };

  const deleteMaterial = async (materialID: string) => {
    try {
      setLoading(true);
      const payload: any = {
        materialID: materialID,
        purchaseID: purchaseID,
        office: currOffice,
      };
      const res = await deleteMaterialService(payload);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("deleteMaterial error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Modal
        title="Allow COM port for Scale Reading (RS323)"
        open={portAccessModalOpen}
        okText="Allow"
        cancelButtonProps={{ style: { display: "none" } }}
        onOk={getPortAccess}
        onCancel={() => setPortAccessModalOpen(false)}
      >
        <p>Select 'USB-Serial Controller (COM3)' and press Connect</p>
      </Modal>
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Col span={24}>
          <Header toggleSidebar={toggleSidebar} />
          <Row className="new-purchase-container">
            <Col style={{ width: "25%" }}>
              <Row className="new-purchase-weight-reading">
                <ScaleReading weight={weight} scaleSerialPort={props.scaleSerialPort} getPortAccess={getPortAccess} />
              </Row>
              <Row className="new-purchase-image-capture">
                <ScaleCamera
                  webcamRef={scaleWebcamRef}
                  webcamName="Scale"
                  imageSrc={scaleImageSrc}
                  // deviceID={webcamDeviceIDs.scaleCameraPG}
                  deviceID={currOffice === "pg" ? webcamDeviceIDs.scaleCameraPG : webcamDeviceIDs.scaleCameraBW}
                />
              </Row>
              <Row className="new-purchase-image-capture">
                <ScaleCamera
                  webcamRef={materialWebcamRef}
                  webcamName="Material"
                  imageSrc={materialImageSrc}
                  deviceID={currOffice === "pg" ? webcamDeviceIDs.materialCameraPG : webcamDeviceIDs.materialCameraBW}
                  // deviceID={webcamDeviceIDs.materialCameraPG}
                />
              </Row>
            </Col>
            <Col style={{ width: "75%" }} className="new-purchase-form">
              <PurchaseForm
                scaleSerialPort={props.scaleSerialPort}
                captureScaleImage={captureScaleImage}
                captureMaterialImage={captureMaterialImage}
                suppliers={suppliers}
                selectedSupplierInfo={selectedSupplierInfo}
                postSupplierSelected={postSupplierSelected}
                recordMaterial={recordMaterial}
                postAddToPurchase={postAddToPurchase}
                putMaterial={putMaterial}
                postCompletePurchase={postCompletePurchase}
                getPurchase={getPurchase}
                getMaterial={getMaterial}
                updateLoading={updateLoading}
                resetNewPurchasePage={resetNewPurchasePage}
                postSupplier={postSupplier}
                postMetal={postMetal}
                deleteMaterial={deleteMaterial}
                getMetals={getMetals}
                getCategories={getCategories}
                resetImageView={resetImageViews}
                scaleImageSrc={scaleImageSrc}
                materialImageSrc={materialImageSrc}
                showSelectSupplierForm={showSelectSupplierForm}
                purchaseInfo={purchaseInfo}
                getSelectedSupplierInfo={getSelectedSupplierInfo}
                toggleSmallTransaction={putSmallTransaction}
                updatePurchaseDate={putPurchaseDate}
              />
            </Col>
          </Row>
        </Col>
        <Copyright />
      </Content>
    </Layout>
  );
};

export default NewPurchasePage;
